// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardContainer:hover {
  transform: scale(1.05);
}

.cardContainer {
  transition: 0.5s;
  position: relative;
  overflow: hidden;
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/component/pages/service-provider-admin/modules/subscriptions-and-addons/subscriptions/Subscriptions.scss"],"names":[],"mappings":"AACE;EACE,sBAAA;AAAJ;;AAGE;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAAJ","sourcesContent":["\n  .cardContainer:hover {\n    transform: scale(1.05);\n  }\n  \n  .cardContainer {\n    transition: 0.5s;\n    position: relative;\n    overflow: hidden;\n    padding: 10px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
